<template lang="html">
  <section class="prt-section-separator">
    <span class="name">{{name}}</span>
    <span class="amount" :class="{negative: amount < 0}" v-if="typeof amount === 'number'">{{amount | transformAmount}}</span>
  </section>
</template>

<script>
export default {
  props: {
    amount: Number,
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-section-separator
    height: 24px
    background-color: white
    box-shadow: 0 2px 4px black-12
    display: flex
    justify-content: space-between
    padding: 0 12px
    line-height: 24px
    position: sticky
    top: 0
    margin-bottom: 8px
    z-index: 3

    .name
      font-size: 12px
      text-transform: uppercase
      font-weight: bold
      letter-spacing: 1px
      color: black-54

    .amount
      font-size: 12px
      font-weight: bold
      color: positive

      &.negative
        color: negative

</style>
